import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface RequireFirebaseAuthProps {
  children: React.ReactNode;
}

const RequireFirebaseAuth: React.FC<RequireFirebaseAuthProps> = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex-1 flex items-center justify-center py-20">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-purple-600" />
      </div>
    );
  }

  if (!currentUser) {
    const callbackUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/signin?callbackUrl=${callbackUrl}`} replace />;
  }

  return <>{children}</>;
};

export default RequireFirebaseAuth;
